import React from 'react';
import PropTypes from 'prop-types';

/**
 * RawHtml component
 * @returns {JSX?}
 */
const RawHtml = ({ content, className, pageUri }) => {
  const style = {};
  const newClass = [className];
  if (['/parking'].includes(pageUri)) {
    //newClass.push('landing_raw');
  } else if (['/cbx-shuttle'].includes(pageUri)) {
    //newClass.push('landing_shuttle');
  } else {
    style.overflow = 'hidden';
  }

  return (
      <div
        className={newClass.join(' ')}
        style={style}
        dangerouslySetInnerHTML={{ __html: content }} // eslint-disable-line react/no-danger
      />
  );
};

RawHtml.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
  pageUri: PropTypes.string,
};

export default RawHtml;
